import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./index.scss";

import hazelcast from "../../../assets/images/hazelcast.png";
import bright from "../../../assets/images/bright.png";
import obsidian from "../../../assets/images/obsidian.png";
import link from "../../../assets/images/link.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import client1 from "../../../assets/images/cl1.png";

import client2 from "../../../assets/images/cl2.png";
// import client3 from "../../../assets/images/cl3.png";
import client4 from "../../../assets/images/cl4.png";
import client5 from "../../../assets/images/cl5.png";
import client6 from "../../../assets/images/cl6.png";
import client7 from "../../../assets/images/cl7.png";
import client8 from "../../../assets/images/cl8.png";
import client9 from "../../../assets/images/cl9.png";
import client10 from "../../../assets/images/cl10.png";
import client11 from "../../../assets/images/cl11.png";
import client12 from "../../../assets/images/cl12.png";
import client13 from "../../../assets/images/cl13.png";
import client14 from "../../../assets/images/cl14.png";
import per1 from "../../../assets/images/per1.png";
import per2 from "../../../assets/images/per2.png";
import per3 from "../../../assets/images/per3.png";
const JoinSection = () => {
  const { t } = useTranslation();
  const settingsRow1 = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3, // Nombre d'images visibles en même temps
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false, // Direction de droite à gauche
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1300, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 2, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 3, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 2, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  const rows1 = [
    { id: 1, image: client1, alt: " brand 1" },
    { id: 2, image: client2, alt: " brand 2" },
    // { id: 3, image: client3, alt: "brand 3" },
    { id: 4, image: client4, alt: "brand 4" },
    { id: 5, image: client5, alt: "brand 5" },
    { id: 6, image: client6, alt: " brand 1" },
    { id: 7, image: client7, alt: " brand 2" },
    { id: 8, image: client8, alt: "brand 3" },
    { id: 9, image: client9, alt: "brand 4" },
    { id: 10, image: client10, alt: "brand 5" },
    { id: 11, image: client11, alt: " brand 1" },
    { id: 12, image: client12, alt: " brand 2" },
    { id: 13, image: client13, alt: "brand 3" },
    { id: 14, image: client14, alt: "brand 4" },
  ];
  return (
    <section className="join-section py-5">
      <Container fluid className="content-mobile">
        <Row className="align-items-end align-items-md-center justify-content-between style-mobile-row">
          {/* Texte à gauche */}
          <Col md={6} className="text-section ps-md-5">
            <h2 className="title mt-5">
              {t("join.title")}
              <br /> MSIT
            </h2>
            <p className="subtitle">{t("join.subtitle")}</p>

            {/* <div className="clients-info d-flex align-items-center gap-3 mt-4">
              <div className="avatars">
                <img src={per1} alt="Avatar 1" className="avatar" />
                <img src={per2} alt="Avatar 2" className="avatar" />
                <img src={per3} alt="Avatar 3" className="avatar" />
              </div>
              <div className="clients">
                100+
                <br />
                <span>{t("join.clients")}</span>
              </div>
            </div> */}

            {/* <div className="trusted mt-5 d-none d-md-block">
              <p className="trusted-text">{t("join.trustedBy")}</p>

              <div className="row ms-0  gx-0">
                <div className="col-12 col-md-8 w-100">
                  <Slider {...settingsRow1}>
                    {rows1.map((row) => (
                      <div key={row.id} className="row-slider3">
                        <img src={row.image} alt={row.alt} />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div> */}
          </Col>

          {/* Image à droite */}
          <Col md={5} className="image-section text-center"></Col>
        </Row>
      </Container>
    </section>
  );
};

export default JoinSection;
